import uniAdminApi from "./api";

const clubService = {
  getClubs: async (page = 0, size = 10, search = "", campusId = null, status = undefined) => {
    const params = { page, size };
    if (search) params.search = search;
    if (campusId) params.campusId = campusId;
    if (status !== undefined && status !== null) params.status = status;
    const res = await uniAdminApi.get("/university-admin/clubs", { params });
    return res.data;
  },

  getClub: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/clubs/${id}`);
    return res.data;
  },

  createClub: async (data) => {
    const res = await uniAdminApi.post("/university-admin/clubs", data);
    return res.data;
  },

  updateClub: async (id, data) => {
    const res = await uniAdminApi.put(`/university-admin/clubs/${id}`, data);
    return res.data;
  },

  deleteClub: async (id) => {
    const res = await uniAdminApi.delete(`/university-admin/clubs/${id}`);
    return res.data;
  },

  getClubMembers: async (clubId, page = 0, size = 20) => {
    const res = await uniAdminApi.get(`/university-admin/clubs/${clubId}/members`, {
      params: { page, size },
    });
    return res.data;
  },

  assignClubRole: async (clubId, userId, role) => {
    const res = await uniAdminApi.post(`/university-admin/clubs/${clubId}/members`, {
      userId,
      role,
    });
    return res.data;
  },

  revokeClubMember: async (clubId, userId) => {
    const res = await uniAdminApi.delete(
      `/university-admin/clubs/${clubId}/members/${userId}/role`,
    );
    return res.data;
  },

  getClubMembersDirectory: async (clubId, page = 0, size = 20) => {
    const res = await uniAdminApi.get(`/university-admin/clubs/${clubId}/members-directory`, { params: { page, size } });
    return res.data;
  },

  exportClubMembersDirectory: async (clubId, format) => {
    return await uniAdminApi.get(`/university-admin/clubs/${clubId}/members-directory/export`, { params: { format }, responseType: "blob" });
  },

  getClubStatistics: async (clubId) => {
    const res = await uniAdminApi.get(`/university-admin/clubs/${clubId}/statistics`);
    return res.data;
  },

  exportClubStatistics: async (clubId) => {
    return await uniAdminApi.get(`/university-admin/clubs/${clubId}/statistics/export`, { responseType: "blob" });
  },

  exportAllClubsReport: async (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return await uniAdminApi.get("/university-admin/clubs/export", { params, responseType: "blob" });
  },
};

export default clubService;
